import React from 'react'

const Icon = ({ name }) => {
  const TheIcon = require(`./svgs/${name}.inline.svg`)
  return <TheIcon />
}

export default Icon
